import { guardNumberPositive } from '../../../utils/guardNumber';
export default function lengthControlToDto(lengthControl) {
    var _a, _b;
    if (lengthControl === undefined) {
        return undefined;
    }
    return {
        character: (_b = (_a = lengthControl.character) === null || _a === void 0 ? void 0 : _a.substring(0, 1)) !== null && _b !== void 0 ? _b : '',
        length: guardNumberPositive(lengthControl.length),
        direction: lengthControl.direction,
        truncate: lengthControl.truncate,
    };
}
